module.exports = "/images/mn.svg?abaf59a585f15c031a22b1b1c1981739";